import { Grid } from '@mui/material'
import Card from './Card'

export default function FundsSummary({ funds, recent50SumAbs, walletsTotal, payoutTotal, onFundClick, onShowAllTransactions, onToggleWallets, onTogglePayouts }) {
  return (
    <Grid container columns={{ xs: 12, md: 24 }} rowSpacing={2} columnSpacing={2}>
      <Grid gridColumn={{ xs: 'span 12', md: 'span 6' }}>
        <Card title="CASHBACK_FUND" value={funds.CASHBACK_FUND} onClick={() => onFundClick('CASHBACK_FUND')} />
      </Grid>
      <Grid gridColumn={{ xs: 'span 12', md: 'span 6' }}>
        <Card title="REFERRAL_FUND" value={funds.REFERRAL_FUND} onClick={() => onFundClick('REFERRAL_FUND')} />
      </Grid>
      <Grid gridColumn={{ xs: 'span 12', md: 'span 6' }}>
        <Card title="MARGIN_FUND" value={funds.MARGIN_FUND} onClick={() => onFundClick('MARGIN_FUND')} />
      </Grid>
      <Grid gridColumn={{ xs: 'span 12', md: 'span 6' }}>
        <Card title="VAT_FUND" value={funds.VAT_FUND} onClick={() => onFundClick('VAT_FUND')} />
      </Grid>
      <Grid gridColumn={{ xs: 'span 12', md: 'span 3' }}>
        <Card title="Všetky transakcie" value={recent50SumAbs} onClick={onShowAllTransactions} />
      </Grid>
      <Grid gridColumn={{ xs: 'span 12', md: 'span 3' }}>
        <Card title="Wallets (súčet)" value={walletsTotal} onClick={onToggleWallets} />
      </Grid>
      <Grid gridColumn={{ xs: 'span 12', md: 'span 6' }}>
        <Card title="Payouts (súčet)" value={payoutTotal} onClick={onTogglePayouts} />
      </Grid>
    </Grid>
  )
}
